module.exports = __webpack_public_path__ + "img/interieur.2d3aefcf.jpg";